import { Color, MediumTextL, VerticalFlex } from "@enxcs/dap-ui-stratos";
import { useTranslation } from "react-i18next";

export const ConfirmStep = () => {
  const { t } = useTranslation();
  return (
    <VerticalFlex>
      <MediumTextL color={Color.Neutral.V60}>{t("prepareModal.completeStep.description")}</MediumTextL>
    </VerticalFlex>
  );
};
